export const EVENT_NAMES = Object.freeze({
  SIGNED_UP: 'Signed Up',
  GATSBY_PAGEVIEW: 'gatsby-pageview',
  LEAD_CAPTURED: 'Lead Captured',
  ORDER_COMPLETED: 'Order Completed',
});

export const TEST_EVENT_NAMES = Object.freeze({
  SIGNED_UP: 'test/Signed Up',
  ORDER_COMPLETED: 'test/Order Completed',
});
